import { createSelector } from 'reselect'

const getStripeSettingsOptions: SelectOptionsSelector = (state) =>
  state.stripeSettings.stripeSettingsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const stripeSettingsSelectOptionsSelector: SelectOptionsSelector = createSelector(getStripeSettingsOptions, (options) => options)
